module.exports = __webpack_public_path__ + "asset/image/ic_jcb-a95c.svg";